import { DatastoreProvider } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { Stack, useLocalSearchParams } from 'expo-router';
import { rankingEvalModuleQuery, useModule } from 'system/structure-modules';

export default function RankingEvalCommentScoringScreen() {
    const { instanceKey, siloKey } = useLocalSearchParams<'/[siloKey]/ranking-eval/one/comment-scoring/[instanceKey]'>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'ranking-eval',
        instanceKey,
        moduleQuery: rankingEvalModuleQuery,
    });
    const { CommentScoringScreen } = useModule(rankingEvalModuleQuery);

    return (
        <>
            <Stack.Screen options={{ title: instanceKey }} />
            <DatastoreProvider {...instanceConfig}>
                <CommentScoringScreen />
            </DatastoreProvider>
        </>
    );
}
